/*
  Honey & Paw: "Load more" for the collection product grid.
  Replaces the numbered pagination with a Load more products button and keeps the
  server-rendered "Showing X of Y products" line ([data-hp-progress]) truthful after
  each append. Progressive enhancement: with JS off (or IntersectionObserver missing)
  the normal pagination is left in place. Survives Dawn's faceted filter/sort, which
  replaces #ProductGridContainer's innerHTML (we re-init via a MutationObserver).

  The button is the deliberate action by default. Only when the container carries
  data-hp-autoload="true" (section setting) does it also act as a scroll sentinel and
  auto-fire when it enters the viewport.
*/
(function () {
  var CONTAINER_ID = 'ProductGridContainer';

  // Dawn quirk: the NEXT-page arrow carries the class `pagination__item--prev`.
  function nextUrlFrom(pagination) {
    if (!pagination) return null;
    var a = pagination.querySelector('a.pagination__item--prev');
    return a && a.href ? a.href : null;
  }

  function InfiniteScroll(container) {
    this.container = container;
    this.setup = this.setup.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.onIntersect = this.onIntersect.bind(this);
    this.setup();
    // Filter/sort re-render replaces the container's innerHTML -> rebuild.
    this.reinit = new MutationObserver(this.setup);
    this.reinit.observe(container, { childList: true });
  }

  InfiniteScroll.prototype.setup = function () {
    if (this.io) { this.io.disconnect(); this.io = null; }
    this.grid = this.container.querySelector('#product-grid');
    var pagination = this.container.querySelector('.pagination-wrapper');
    this.loading = false;

    if (!this.grid || !pagination) {
      this.container.classList.remove('hp-inf-active');
      return;
    }
    this.nextUrl = nextUrlFrom(pagination);
    if (!this.nextUrl) {
      this.container.classList.remove('hp-inf-active');
      return;
    }
    this.container.classList.add('hp-inf-active'); // hides the numbered pagination via CSS
    this.ensureButton();
    this.autoload = this.container.getAttribute('data-hp-autoload') === 'true';
    if (this.autoload) {
      this.io = new IntersectionObserver(this.onIntersect, { rootMargin: '800px 0px' });
      this.io.observe(this.button);
    }
  };

  InfiniteScroll.prototype.ensureButton = function () {
    if (!this.button) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'button button--secondary hp-inf-more';
      btn.innerHTML = '<span class="hp-inf-more__label">Load more products</span><span class="hp-inf-more__spinner" aria-hidden="true"></span>';
      btn.addEventListener('click', this.loadMore);
      this.button = btn;
      this.label = btn.querySelector('.hp-inf-more__label');
    }
    // keep it as the last child of the collection area, after the grid
    this.grid.parentNode.appendChild(this.button);
    this.button.hidden = false;
  };

  InfiniteScroll.prototype.onIntersect = function (entries) {
    if (entries[0] && entries[0].isIntersecting) this.loadMore();
  };

  InfiniteScroll.prototype.loadMore = function () {
    var self = this;
    if (this.loading || !this.nextUrl) return;
    this.loading = true;
    this.container.classList.add('hp-inf-loading');
    if (this.label) this.label.textContent = 'Loading...';

    fetch(this.nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (!newGrid) throw new Error('no grid in response');

        var frag = document.createDocumentFragment();
        // The reassurance tile ([data-hp-promo]) belongs to page 1 only; never re-append it.
        newGrid.querySelectorAll(':scope > li:not([data-hp-promo])').forEach(function (li) {
          var node = document.importNode(li, true);
          // guarantee visibility even when scroll-reveal animations are enabled
          node.classList.remove('scroll-trigger', 'animate--slide-in');
          node.removeAttribute('data-cascade');
          if (node.style) node.style.removeProperty('--animation-order');
          frag.appendChild(node);
        });
        self.grid.appendChild(frag);

        // Keep "Showing X of Y products" truthful: the fetched page's line already carries
        // its own cumulative offset + count, so copying it in is exact.
        var newProgress = doc.querySelector('[data-hp-progress]');
        var curProgress = self.container.querySelector('[data-hp-progress]');
        if (newProgress && curProgress) curProgress.innerHTML = newProgress.innerHTML;

        self.nextUrl = nextUrlFrom(doc.querySelector('.pagination-wrapper'));
        self.loading = false;
        self.container.classList.remove('hp-inf-loading');

        if (self.nextUrl) {
          if (self.label) self.label.textContent = 'Load more products';
          self.ensureButton(); // move button back to the end, keep observing
        } else {
          self.finish();
        }
      })
      .catch(function () {
        // Stop auto-loading and hand control back to the shopper.
        self.loading = false;
        self.container.classList.remove('hp-inf-loading');
        if (self.io) { self.io.disconnect(); self.io = null; }
        if (self.label) self.label.textContent = 'Load more products';
      });
  };

  InfiniteScroll.prototype.finish = function () {
    if (this.io) { this.io.disconnect(); this.io = null; }
    if (this.button) this.button.hidden = true;
  };

  function init() {
    var container = document.getElementById(CONTAINER_ID);
    if (!container || container.__hpInfinite) return;
    if (!('IntersectionObserver' in window)) return; // leave pagination for old browsers
    container.__hpInfinite = new InfiniteScroll(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
